import apiService from '../apiService';
import { store } from '../store';
import { getUser, setUser } from '@/utils/localStorage';

export const addTagTypes = ['Addresses_List'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getAddressesList: build.query<any, any>({
				query: ({ selected_address_id, per_page, ...rest }) => ({
					url: `address`,
					params: {
						per_page,
						selected_address_id,
						...rest
					}
				}),
				providesTags: ['Addresses_List'],
				async onQueryStarted(_arg, { queryFulfilled }) {
					try {
						const { data: result } = await queryFulfilled;
						const addresses = result?.data;
						if (!Array.isArray(addresses)) {
							return;
						}
						const stored = getUser();
						if (stored == null) {
							return;
						}
						const nextTotal = addresses.length;
						if (stored.total_number_of_addresses === nextTotal) {
							return;
						}
						setUser({ ...stored, total_number_of_addresses: nextTotal });
					} catch {
						// Failed or aborted fetch — keep existing stored user
					}
				}
			}),
			createAddress: build.mutation({
				query: ({ payload }) => ({
					url: 'address/store',
					method: 'POST',
					body: payload
				}),
				invalidatesTags: ['Addresses_List']
			}),
			updateAddress: build.mutation<any, any>({
				query: ({ payload }) => ({
					url: `address/update`,
					method: 'PUT',
					body: payload
				}),
				invalidatesTags: ['Addresses_List']
			})
		})
	});

/**
 * Refetches all active `GET /address` queries (subscribed `useGetAddressesListQuery` hooks).
 * Also runs `onQueryStarted` side effects (e.g. syncing `total_number_of_addresses` in localStorage).
 */
export function refetchAddressesList() {
	return store.dispatch(applicationsApi.util.invalidateTags(['Addresses_List']));
}

export const {
	useGetAddressesListQuery,
	useLazyGetAddressesListQuery,
	useCreateAddressMutation,
	useUpdateAddressMutation
} = applicationsApi;
